'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _user_recharge = require('./user_recharge');

var _user_recharge2 = _interopRequireDefault(_user_recharge);

var _currency_display = require('./currency_display');

var _currency_display2 = _interopRequireDefault(_currency_display);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
    displayName: 'user_finance',
    recharge: function recharge(form) {

    },
    refund: function refund() {

    },
    deduct: function deduct() {

    },
    render: function render() {
        return _react2.default.createElement(
            'dl',
            null,
            _react2.default.createElement(
                'dt',
                null,
                '\u8D26\u6237\u4F59\u989D\uFF1A'
            ),
            _react2.default.createElement(
                'dd',
                null,
                _react2.default.createElement(_currency_display2.default, { style: { marginRight: 25 }, money: this.props.user.balance }),
                _react2.default.createElement(_user_recharge2.default, null),
                _react2.default.createElement(
                    _button2.default,
                    { onClick: this.refund },
                    '\u9000\u6B3E'
                ),
                _react2.default.createElement(
                    _button2.default,
                    { onClick: this.deduct, style: { marginLeft: 10 } },
                    '\u6263\u6B3E'
                )
            )
        );
    }
}); /**
     * 客户财务信息
     */


//////////////////
// WEBPACK FOOTER
// ./src/js/components/user_finance.js
// module id = 1329
// module chunks = 0